import React from 'react';

import { Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const EditionButtons = ({
    canModify,
    editionDisabled,
    handleClickCancel,
    handleClickSave,
    isUpdatingCustomTemplate,
}) => {
    const { t } = useTranslation();

    return (
        <Grid container sx={{ my: 1 }}>
            <Grid size="grow" sx={{ display: 'flex', flexDirection: 'column' }}>
                {canModify && !editionDisabled && (
                    <Button
                        fullWidth
                        onClick={handleClickSave}
                        type="button"
                        sx={{ mb: 2 }}
                        variant="outlined"
                    >
                        {isUpdatingCustomTemplate
                            ? t('Saving').concat('...')
                            : t('Save')}
                    </Button>
                )}
                {!editionDisabled && (
                    <Button
                        color="secondary"
                        fullWidth
                        onClick={handleClickCancel}
                        type="button"
                        variant="text"
                    >
                        {t('Cancel')}
                    </Button>
                )}
            </Grid>
        </Grid>
    );
};

EditionButtons.propTypes = {
    canModify: PropTypes.bool,
    editionDisabled: PropTypes.bool,
    handleClickCancel: PropTypes.func,
    handleClickSave: PropTypes.func,
    isUpdatingCustomTemplate: PropTypes.bool,
};

export default EditionButtons;
